import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledShipperOrders = styled(Flexer.Parent)`
  && > label {
    display: block;
    width: 33%;
    &:last-child {
      margin-bottom: inherit;
    }
  }
`;

export const StyledLogAssignation = styled.p`
  color: var(--grey700);
`;

export const StyledJourneyTag = styled.div`
  color: var(--grey700);
  background-color: var(--grey100);
  padding: 0.4rem;
  border-radius: 2px;
`;

export default StyledShipperOrders;
